// Customer store slice types and initial state

// ─── Types ───────────────────────────────────────────────────────────

export interface Customer {
  id: number;
  username: string;
  display_name: string | null;
  email: string | null;
  role: 'customer' | 'admin';
  is_active: boolean;
  created_at: string;
}

export interface CreateCustomerRequest {
  username: string;
  password: string;
  display_name?: string;
  email?: string;
  role?: 'customer' | 'admin';
}

export interface UpdateCustomerRequest {
  display_name?: string;
  email?: string;
  role?: 'customer' | 'admin';
  is_active?: boolean;
  password?: string;
}

/** A legacy LICK/SLIC key imported by a customer (GET /admin/imported-keys). Masked only. */
export interface ImportedKey {
  id: number;
  key_type: 'LICK' | 'SLIC';
  key_masked: string;
  lick_id: number | null;
  legacy_pid: number | null;
  product_name: string | null;
  seats: number | null;
  sub_end: string | null;
  /** imported | unsupported_product | revoked (imported, entitlement deleted) | ... */
  status: string;
  entitlement_id: number | null;
  products: { product_id: number; seats: number }[];
  expired: boolean;
  created_at: string;
}

// ─── Slice State Interface ───────────────────────────────────────────

export interface CustomerState {
  customers: Customer[];
  selectedCustomer: Customer | null;
  isLoading: boolean;
  error: string | null;
}

// ─── Initial State ───────────────────────────────────────────────────

export const initialCustomerState: CustomerState = {
  customers: [],
  selectedCustomer: null,
  isLoading: false,
  error: null,
};
